module.exports = __webpack_public_path__ + "img/logo_u1992-1.db6ea190.svg";